import NetworkService from '../services/network.service'

class TicketApi {
  getTickets = async (query: any) => {
    let url = `api/tickets`;
    let config = {
      params: {
        query: query
      }
    }
    let data = await NetworkService.get(url, config)
    return data && data.data
      ? data.data : data

  };
  deleteTicket = async (id: any) => {
    try {
      let url = `api/tickets/delete`;
      let body = { id: id };
      let data = await NetworkService.delete(url, body)
      return data && data.data
        ? data.data : data
    } catch (err: any) {
      return err.description ? err.description : err;
    }
  }
  // following function is no longer used
  // deleteTicket = async (ticketId: any) => {
  //   let url = `api/tickets/delete`;
  //   let body = {
  //     id: ticketId
  //   }
  //   let data = await NetworkService.put(url, body)
  //   return data && data.data
  //     ? data.data : data
  // }
}
export default TicketApi;